module.exports = __webpack_public_path__ + "media/images/common/shop/icon-shop-7d01bdfdcf89b0074065a1b2abca9f64.png";